// removed by extract-text-webpack-plugin
module.exports = {"base":"Direction_base--3OPCh","icon":"Direction_icon--LxwrV","base__bonus":"Direction_base__bonus---Dx4x","baseBonus":"Direction_base__bonus---Dx4x","base__battle":"Direction_base__battle--2xHvX","baseBattle":"Direction_base__battle--2xHvX","bonus":"Direction_bonus--2Efhz","battle":"Direction_battle--3kmCN","shortName":"Direction_shortName--1DG07"};


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Direction/Direction.scss
// module id = 492
// module chunks = 11 12